import {Injectable} from '@angular/core';
import {BaseService} from '../shared/services/base.service';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainService extends BaseService {
  /**
   * Đăng nhập. Dùng MobileLoginV2 vì chỉ bản V2 mới trả về accessToken.
   *
   * Body và response giống hệt bản cũ, chỉ thêm trường accessToken. mSchool tách
   * action mới thay vì sửa action cũ vì MobileLogin trả chuỗi JSON do tầng dưới
   * dựng sẵn — thêm trường vào đó sẽ đổi thứ tự trường và cách escape, mà app cũ
   * đang đọc chính chuỗi ấy.
   *
   * Trường `token` cũ trong response vẫn còn và vẫn vô dụng như trước. Thứ dùng
   * để xác thực là `accessToken`.
   */
  login(username: any, password: any, deviceInfo: any): any {
    const item = {
      username, password,
      regId: deviceInfo.regId,
      deviceId: deviceInfo.deviceId,
      deviceName: deviceInfo.deviceName
    };
    return this.post(`/api/Mobile/MobileLoginV2`, item);
  }

  /**
   * Gia hạn accessToken tại chỗ, không cần mật khẩu.
   * Dùng AuthTokenService.renew() ở hầu hết các chỗ; hàm này để sẵn cho màn nào
   * cần gọi thẳng.
   */
  renewAccessToken(): any {
    return this.post(`/api/Mobile/RenewAccessToken`, {});
  }

  getUserInfo(userType: any, personId: any): any {
    const item = {
      userType, personId
    };
    return this.post(`/api/mobile/getUserInfo`, item);
  }

  changePassword(userId: any, password: any, oldPassword: any, repeatPassword: any): any {
    const item = {
      accountId: userId,
      password,
      oldPassword,
      repeatPassword
    };
    return this.post(`/api/mobile/changePassword`, item);
  }

  logoutAndUnregisDevice(regId: any) {
    return this.get(`/api/Mobile/UnRegisterDevice?regid=${regId}`);
  }

  /*loginTest(){
    let payload = {'username':'admin','password':'123456'};
    return this.postLocal(`https://listest.stc.vn:8643/login`, payload);
  }*/
  getListMessage(studentId, month, year) {
    return this.get(`/api/mobile/getListMesageByUserId3?userId=${studentId}&month=${month}&year=${year}`);
  }

  getUnReadMessageCount(studentId) {
    return this.get(`/api/Mobile/GetUnReadMessageCount?userId=${studentId}`);
  }

  getMessageDetail(studentId, type, msgId) {
    return this.get(`/api/Mobile/GetMessageDetail?userId=${studentId}&type=${type}&messageId=${msgId}`);
  }

  getStudentAbsence(studentId) {
    return this.get(`/api/mobile/getStudentAbsence?studentId=${studentId}&token=${studentId}`);
  }

  getStudentReviewMark(studentId) {
    return this.get(`/api/mobile/getStudentReviewMark?studentId=${studentId}&token=${studentId}`);
  }

  getMarkByStudent(studentId, term) {
    return this.get(`/api/mobile/getMarkByStudent?studentId=${studentId}&token=61d505a18491e62fb4e390cb&term=${term}`);
  }

  getListContact(studentId, userType) {
    return this.get(`/api/mobile/getListStaffsConversationNew?userId=${studentId}&userType=${userType}&token=61d505a18491e62fb4e390cb`);
  }

  getConversation(schoolId, studentId, userType) {
    return this.get(`/api/mobile/getConversation?schoolId=${schoolId}&curUserId=${studentId}&userType=${userType}`);
  }

  getFeedback(schoolId, studentId, userType, convId) {
    return this.get(`/api/mobile/getListFeedbackOfConversation?schoolId=${schoolId}&curUserId=${studentId}&curUserType=${userType}&toUserId=0&convId=${convId}&deviceId=a`);
  }

  createConversation(schoolId, fromUserId, fromUserType, toUserId, toUserType, message, deviceId, convId) {
    fromUserType = fromUserType === 12 ? 4 : fromUserType;
    return this.get(`/api/mobile/createConversation?schoolId=${schoolId}&fromUserId=${fromUserId}&fromUserType=${fromUserType}&toUserId=${toUserId}&toUserType=${toUserType}&message=${message}&deviceId=${deviceId}&convId=${convId}`);
  }

  getListClassByTeacher(teacherId, schoolId) {
    return this.get(`/api/mobile/getListClassByTeacher?teacherId=${teacherId}&schoolId=${schoolId}&token=${schoolId}`);
  }

  getListClassScheduleByTeacher(teacherId, schoolId, dateSchedule) {
    const payload = {
      teacherId,
      schoolId,
      dateSchedule,
      token: schoolId
    };
    return this.post(`/api/mobile/GetListClassScheduleByTeacher`, payload);
  }

  getStudentByClassId(classId) {
    return this.get(`/api/mobile/getStudentByClassId?token=${classId}&clsId=${classId}`);
  }

  sendSMS(receiveType, toIds, messageContent, fromUserId, fromUserType) {
    const payload = {
      type: receiveType,
      ids: toIds,
      message: messageContent,
      userid: fromUserId,
      usertype: fromUserType
    };
    return this.post(`/api/mobile/sendSMS2`, payload);
    //return this.get(`/api/mobile/sendSMS?type=${receiveType}&ids=${toIds}&message=${messageContent}&userid=${fromUserId}&usertype=${fromUserType}`);
  }

  sendMediaMessage(studentIds, fullname, userid, usertype, title, message, fileBytes, fileNames, schoolId, receiveType) {
    const payload = {
      studentIds, fullname, userid, usertype, title, message, fileBytes, fileNames, schoolId, receiveType
    }
    return this.post(`/api/Mobile/SendMediaMessage`, payload);
  }

  sendScheduleNews(studentIds, fullname, userid, usertype, title, message, fileBytes, fileNames, schoolId, receiveType,
                   scheduleDate, classId, fileNameArr) {
    const payload = {
      studentIds,
      fullname,
      userid,
      usertype,
      title,
      message,
      fileBytes,
      fileNames,
      schoolId,
      receiveType,
      scheduleDate,
      classId,
      fileNameArr
    }
    return this.post(`/api/Mobile/SendScheduleNews`, payload);
  }

  getListDepartments(schoolId) {
    return this.get(`/api/Mobile/GetListDepartments?schoolId=${schoolId}&token=${schoolId}`);
  }

  getListStaffByDepartment(schoolId, departmentId) {
    return this.get(`/api/Mobile/GetListStaffByDepartment?schoolId=${schoolId}&departmentId=${departmentId}&token=${schoolId}`);
  }

  getListAbsenceByClass(classId, date: Date, type) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    return this.get(`/api/Mobile/GetListAbsenceByClass?classId=${classId}&month=${month}&day=${day}&year=${year}&type=${type}`);
  }

  getListAbsenceActivityByClass(classId, date: Date, type) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    return this.get(`/api/AbsenceStudent/GetListAbsenceByClass?classId=${classId}&month=${month}&day=${day}&year=${year}&type=${type}`);
  }

  getListAbsenceActivityByClassCustom(schoolId, classId, date: Date, type) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    return this.get(`/api/AbsenceClassCustom/GetListAbsenceByClass?schoolId=${schoolId}&classId=${classId}&month=${month}&day=${day}&year=${year}&type=${type}`);
  }

  getListStaffAbsence(schoolId, date: Date, type) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    return this.get(`/api/Mobile/GetStaffAbsences?schoolId=${schoolId}&month=${month}&day=${day}&year=${year}&type=${type}`);
  }

  updateAbsence(studentId, date: Date, type, absenceValue, fromUserId, fromUserType) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    // eslint-disable-next-line max-len
    //return this.get(`/api/Mobile/UpdateAbsence?studentId=${studentId}&month=${month}&day=${day}&year=${year}&type=${type}&absenceType=${absenceValue}`);

    return this.get(`/api/Mobile/UpdateAbsence2?studentId=${studentId}&month=${month}&day=${day}&year=${year}&type=${type}&absenceType=${absenceValue}&fromUserId=${fromUserId}&fromUserType=${fromUserType}`);
  }

  updateAbsenceActivity(studentId, date: Date, type, absenceValue) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    // eslint-disable-next-line max-len
    return this.get(`/api/AbsenceStudent/UpdateAbsenceActivity?studentId=${studentId}&month=${month}&day=${day}&year=${year}&type=${type}&absenceType=${absenceValue}`);
  }

  updateAbsenceClassCustom(studentId, classId, date: Date, type, absenceValue) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    // eslint-disable-next-line max-len
    return this.get(`/api/AbsenceClassCustom/UpdateAbsenceActivity?studentId=${studentId}&classId=${classId}&month=${month}&day=${day}&year=${year}&type=${type}&absenceType=${absenceValue}`);
  }

  updateStaffAbsence(studentId, date: Date, type, absenceValue, minutes) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/UpdateStaffAbsence?studentId=${studentId}&month=${month}&day=${day}&year=${year}&type=${type}&absenceType=${absenceValue}&minutes=${minutes}`);
  }

  getReviewMarkByClass(classId, subjectId, date: Date, type, week) {
    const month = date.getMonth() + 1;
    let day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    if (type === 3) {
      day = this.getDayOfYear(date);
    }
    // eslint-disable-next-line max-len
    const url = `/api/Mobile/GetReviewMarkByClass?classId=${classId}&week=${week}&month=${month}&day=${day}&year=${year}&type=${type}&subjectId=${subjectId}`;
    return this.get(url);
  }

  getCommentSource(schoolId) {
    return this.get(`/api/Mobile/GetCommentSource?schoolId=${schoolId}`);
  }

  getDayOfYear(date = new Date()) {
    const timestamp1 = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    );
    const timestamp2 = Date.UTC(date.getFullYear(), 0, 0);
    const differenceInMilliseconds = timestamp1 - timestamp2;
    const differenceInDays = differenceInMilliseconds / 1000 / 60 / 60 / 24;
    return differenceInDays;
  }

  updateReview(studentId, subjectId, date: Date, type, week, notes, commentIds) {
    const month = date.getMonth() + 1;
    let day = date.getDate();
    const year = date.getFullYear();
    if (type === 3) {
      day = this.getDayOfYear(date);
    }
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/UpdateReviewMarkByStudent?studentId=${studentId}&week=${week}&month=${month}&day=${day}&year=${year}&type=${type}&commentIds=${commentIds}&notes=${notes}&subjectId=${subjectId}`);
  }

  sendAbsence(userId, userName, studentIds, date: Date, type, userType) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/SendAbsence?userId=${userId}&userName=${userName}&ut=${userType}&studentIds=${studentIds}&month=${month}&day=${day}&year=${year}&type=${type}`);
  }

  sendReviewMark(userId, subjectId, userName, studentIds, date: Date, type, userType, week) {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    console.log(day, month, year);
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/SendReviewMark?userId=${userId}&userName=${userName}&ut=${userType}&studentIds=${studentIds}&month=${month}&day=${day}&year=${year}&type=${type}&week=${week}&subjectId=${subjectId}`);
  }

  getSMSSendingLog(userId, userType, fromDate, toDate) {
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/GetListSendingLog?userId=${userId}&userType=${userType}&token=${userId}&fromdate=${fromDate}&todate=${toDate}`);
  }

  getSendingLogDetail(logId) {
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/GetSendingLogDetail?logId=${logId}`);
  }

  getMediaLog(userId, schoolId, toUserType, fromDate, toDate) {
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/GetListMediaLog?creatorId=${userId}&schoolId=${schoolId}&fromUserType=${toUserType}&fromDate=${fromDate}&toDate=${toDate}`);
  }

  getReciveList(userIds, userType) {
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/GetMediaLogDetail?userIds=${userIds}&userType=${userType}`);
  }

  getSchoolArticle(schoolId) {
    const payload = {
      schoolId,
      classId: '',
      page: 1,
      pageSize: 100
    };
    return this.post(`/api/Article/GetList`, payload);
  }

  /** Như getSchoolArticle nhưng cho phép chỉ định trang — dùng ở màn danh sách bài viết */
  getSchoolArticlePaged(schoolId, page: number = 1, pageSize: number = 20) {
    const payload = {
      schoolId,
      classId: '',
      page,
      pageSize
    };
    return this.post(`/api/Article/GetList`, payload);
  }

  approveRequestPermission(studentId) {
    return this.get(`/api/Mobile/ApproveRequestPermission/${studentId}`);
  }

  approveRequestPermissionNew(payload) {
    return this.post(`/api/RequestPermission/ApproveRequestPermission`, payload);
  }

  getListRequestPermission(studentId) {
    return this.get(`/api/Mobile/GetListRequestPermission?userId=${studentId}`);
  }

  getListRequestPermissionNew(studentId) {
    return this.get(`/api/RequestPermission/GetListRequestPermission?userId=${studentId}`);
  }

  uploadArticleImage(formData: any, schoolId): Observable<any> {
    return this.post(`/api/Article/UploadFile/${schoolId}`, formData);
  }

  uploadFile(formData: any, schoolId): Observable<any> {
    return this.post(`/api/Article/UploadFile2/${schoolId}`, formData);
  }

  uploadAvatar(formData: any, schoolId, accountId): Observable<any> {
    return this.post(`/api/Mobile/UploadAvatar?schoolId=${schoolId}&accId=${accountId}`, formData);
  }

  uploadStudentAvatar(formData: any, schoolId, studentId): Observable<any> {
    return this.post(`/api/Mobile/UploadStudentAvatar?schoolId=${schoolId}&studentId=${studentId}`, formData);
  }

  createArticle(payload) {
    return this.post(`/api/Article/Post`, payload);
  }

  getSchoolNewFeed(schoolId, classId) {
    const payload = {
      schoolId,
      classId,
      page: 1,
      pageSize: 100,
      isFeed: true,
    };
    return this.post(`/api/Article/GetList`, payload);
  }

  getSchoolNewFeedByOnlyUser(schoolId, classId, createUserId) {
    const payload = {
      schoolId,
      classId,
      page: 1,
      pageSize: 100,
      isFeed: true,
      createUserId
    };
    return this.post(`/api/Article/GetList`, payload);
  }

  deleteFeed(feedId) {
    return this.delete(`/api/Article/delete/${feedId}`, null);
  }

  articleComment(payload) {
    return this.post(`/api/Article/PostComment`, payload);
  }

  likeFeed(payload) {
    return this.post(`/api/Article/LikeFeed`, payload);
  }

  likeComment(payload) {
    return this.post(`/api/Article/LikeComment`, payload);
  }

  getArticleById(id) {
    return this.get(`/api/Article/GetById/${id}`);
  }

  getCommentByFeed(feedId) {
    return this.get(`/api/Article/GetCommentLikes?feedId=${feedId}`);
  }

  getLikeByFeed(feedId) {
    return this.get(`/api/Article/GetFeedLikes?feedId=${feedId}`);
  }

  getPollingTreeSource(schoolId) {
    return this.get(`/api/Polling/GetTreeSource?schoolId=${schoolId}`);
  }

  savePollingForm(payload) {
    return this.post(`/api/Polling/SavePollingForm`, payload);
  }

  getListPoll(schoolId, userId, userType) {
    return this.get(`/api/Polling/GetListPoll?schoolId=${schoolId}&userId=${userId}&ut=${userType}`);
  }

  getListHomeWork(schoolId, classIds, subjectId, userId) {
    subjectId = subjectId ? subjectId : '';
    return this.get(`/api/HomeWork/GetListHomework?schoolId=${schoolId}&classIds=${classIds}&subjectId=${subjectId}&teacherId=${userId}`);
  }

  getPollById(pollId) {
    return this.get(`/api/Polling/GetPollingById/${pollId}`);
  }

  getListPollByUser(schoolId, userId) {
    return this.get(`/api/Polling/GetListUserPoll?schoolId=${schoolId}&userId=${userId}`);
  }

  choosePollingAnswer(payload) {
    return this.post(`/api/Polling/ChooseAnswer`, payload);
  }

  getUserPollById(pollId, userId) {
    return this.get(`/api/Polling/GetUserPollingById/${pollId}?userId=${userId}`);
  }

  getPollAnswerByClass(pollId, classId) {
    return this.get(`/api/Polling/GetAnswersByGroup?pollingId=${pollId}&groupId=${classId}&groupType=1`);
  }

  deletePoll(id) {
    return this.post(`/api/Polling/DeletePollingForm/${id}`, null);
  }

  getCurrentVersion() {
    return this.get(`/api/Mobile/GetCurrentVersion`);
  }

  countHomework(studentId) {
    return this.get(`/api/Homework/CountHomeworkByStudent?studentId=${studentId}`);
  }

  saveHomeWork(payload) {
    return this.post(`/api/HomeWork/CreateHomework`, payload);
  }

  getStudentHomeWork(studentId) {
    return this.get(`/api/Homework/GetListHomeworkByStudent?studentId=${studentId}`);
  }

  saveHomeWorkResult(payload) {
    return this.post(`/api/Homework/SaveHomeworkResult`, payload);
  }

  getListHomeworkResultByClass(homeworkId, classId) {
    return this.get(`/api/Homework/GetListHomeworkResultByClass?homeworkId=${homeworkId}&classId=${classId}`);
  }

  teacherMarking(payload) {
    return this.post(`/api/HomeWork/TeacherMarking`, payload);
  }

  deleteHomework(id) {
    return this.delete(`/api/Homework/Delete/${id}`, id);
  }

  /*room registation*/
  getListRooms(schoolId) {
    // eslint-disable-next-line max-len
    return this.get(`/api/RoomRegistration/GetListRoom?schoolId=${schoolId}`);
  }

  saveRoomRegistration(payload) {
    return this.post(`/api/RoomRegistration/SaveRoomRegistration`, payload);
  }

  searchRoomRegistration(payload) {
    return this.post(`/api/RoomRegistration/SearchRoomRegistration`, payload);
  }

  deleteRoomRegistration(id) {
    return this.post(`/api/RoomRegistration/DeleteRoomRegistration/${id}`, null);
  }

  /*day tot*/
  saveObservationRegistration(payload) {
    return this.post(`/api/Observation/SaveRoomRegistration`, payload);
  }

  searchObservationRegistration(payload) {
    return this.post(`/api/Observation/SearchObservationRegistration`, payload);
  }

  deleteObservationRegistration(id) {
    return this.post(`/api/Observation/DeleteObservationRegistration/${id}`, null);
  }

  getCameraLog(studentId, date) {
    return this.get(`/api/CameraAI/GetCameraLog?studentId=${studentId}&date=${date}`);
  }
  getTeacherCamLog(teacherId, date) {
    return this.get(`/api/CameraAI/GetTeacherCameraLog?teacherId=${teacherId}&date=${date}`);
  }

  getHocSinhTokenSSO() {
    const returnUrl = 'https://lms.mschool.edu.vn';
    return this.getLocal(environment.apiLmsUrl + `/Login/SSOLoginModel?isHocSinh=true&returnURL=${returnUrl}`);
  }

  getGiaoVienTokenSSO(schoolId) {
    const returnUrl = 'https://lms.mschool.edu.vn';
    return this.getLocal(environment.apiLmsUrl + `/Login/SSOLoginModel?schoolId=${schoolId}&isHocSinh=false&returnURL=${returnUrl}`);
  }

  ssoLogin(gdToken: any, deviceInfo: any) {
    const item = {
      regId: deviceInfo.regId,
      deviceId: deviceInfo.deviceId,
      deviceName: deviceInfo.deviceName,
      gdToken
    };
    // V2: giống hệt mobileSSOLogin, chỉ THÊM accessToken.
    //
    // Đường SSO trước đây KHÔNG được cấp accessToken, nên tài khoản vào từ CSDL
    // ngành không dùng được các API mới — mà app lại không giữ mật khẩu của họ
    // nên cũng không tự đăng nhập ngầm lấy token được. Phải đổi sang V2.
    return this.post(`/api/Mobile/MobileSSOLoginV2`, item);
    // return this.postLocal(`https://apilms.lienlacdientu.vn/Login/SSOLogin`, item);
  }

  getHCMSchools() {
    return this.getLocal(environment.apiLmsUrl + `/Login/HCMSchools`);
  }

  hasModifyStudentInfo(studentId, type, classId, curYear, phone) {
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/HasModifyStudentInfo?studentId=${studentId}&userType=${type}&classId=${classId}&phoneNumber=${phone}&currentYear=${curYear}`);
  }

  hasModifyTeacherInfo(studentId, classId, classIds, curYear, phone) {
    // eslint-disable-next-line max-len
    return this.get(`/api/Mobile/HasModifyTeacherInfo?staffId=${studentId}&classId=${classId}&classIds=${classIds}&currentYear=${curYear}&phoneNumber=${phone}`);
  }

  getLMSToken(userId: any, userType: number, schoolId: any) {
    return this.get(`/api/Mobile/GetLoginToken?uId=${userId}&uType=${userType}&sId=${schoolId}`);
  }

  // Banner thuc don da kiem duyet tren trang chu
  getMenuBanner(schoolId) {
    return this.get(`/api/SchoolMenuLink/GetBanner?schoolId=${schoolId}`);
  }

  getSchoolConfig(schoolId) {
    return this.get(`/api/Mobile/GetSchoolConfig?schoolId=${schoolId}`);
  }

  /**
   * Xin link thoi khoa bieu giao vien da duoc server ky (exp + sig).
   * App KHONG tu ghep link va KHONG giu khoa bi mat.
   * Server tra ve: { teacherName, path, url, signed }
   */
  getTeacherScheduleUrl(teacherId: any, hours: number = 12) {
    return this.get(`/api/PublicLink/GetTeacherScheduleUrl?teacherId=${teacherId}&hours=${hours}`);
  }

  /**
   * Xin link học bạ điện tử đã được server ký (path|stuId|exp, HMAC-SHA256).
   *
   * BẮT BUỘC có Bearer token — server kiểm stuId có nằm trong Parents.StudentIds
   * của tài khoản đang đăng nhập không. Chữ ký chỉ chống sửa URL, không chống
   * việc xin link hộ người khác; lớp chặn thật nằm ở chính endpoint này.
   *
   * Server trả về: { studentName, path, url, signed, hasData }
   * Server tự chặn trên hours ở mức 6.
   */
  getStudentTranscriptUrl(stuId: any, hours: number = 2) {
    return this.get(`/api/PublicLink/GetStudentTranscriptUrl?stuId=${stuId}&hours=${hours}`);
  }
}
